var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216.88 53.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #003780;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.76,28.47h-7.41l3.94-12.87,3.46,12.87Zm-11.25,14.18l2.53-8.47h9.98l2.37,8.45h9.22L23.45,10.41c-.54-1.9-1.68-2.78-3.68-2.78H6.68v3.04h1.09c1.37,0,2.1,.54,2.1,1.58,0,.69-.15,1.26-.69,2.83L0,42.65H8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.28,42.65V10.31c0-1.69-.99-2.69-2.62-2.69h-8.11v3.04h.54c1.36,0,1.94,.58,1.94,1.96v30.03h8.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.3,42.65V10.31c0-1.69-1-2.69-2.63-2.69h-8.08v3.04h.54c1.37,0,1.95,.58,1.95,1.96v30.03h8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.68,10.82c0-2.35-1.74-3.8-4.73-3.8s-4.74,1.42-4.74,3.8,1.8,3.8,4.74,3.8,4.73-1.41,4.73-3.8m-.16,31.84V19.08c0-1.68-1-2.67-2.63-2.67h-7.98v2.98h.47c1.36,0,1.94,.63,1.94,2v21.27h8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.58,30.05v5.11c-1.37,1.42-3.04,2.28-4.46,2.28s-2-.73-2-2.71,.41-2.83,1.89-3.4c1.47-.6,3-1.03,4.57-1.28m-11.09-6.13c2.52-1.25,5.28-1.95,8.09-2.05,2.21,0,3,.79,3,3.08v.59c-3.36,.54-4.41,.75-6.3,1.17-1.06,.23-2.1,.56-3.1,.97-3.31,1.33-4.88,3.89-4.88,7.82,0,4.99,2.17,7.4,6.61,7.4,1.51,0,3.01-.28,4.42-.83,1.28-.58,2.46-1.34,3.52-2.26v.37c0,1.63,.84,2.46,2.47,2.46h7.51v-2.8h-.37c-1.42,0-1.94-.63-1.94-2.31v-12.51c0-6.67-2.32-8.99-9-8.99-2.12,.01-4.23,.26-6.29,.74-1.95,.43-3.82,1.14-5.57,2.1l1.83,5.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.79,42.65V24.9c1.37-1.52,2.78-2.21,4.41-2.21,1.74,0,2.17,.69,2.17,3.33v16.63h8.19V24.8c0-4.16-.3-5.47-1.63-6.88-1.09-1.22-2.78-1.84-4.95-1.84-3.21,0-5.46,.99-8.5,3.83v-1.05c0-1.63-.85-2.47-2.53-2.47h-7.79v2.98h.47c1.36,0,1.95,.63,1.95,2v21.27h8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.86,37.14h-11.43l10.93-15.33v-5.43h-17.14c-1.94,0-2.84,.89-2.84,2.84v4.77h3.04v-.47c0-1.21,.63-1.78,1.94-1.78h5.89l-11.05,15.5v5.43h20.62l.04-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.87,41.99V12.3c0-2.37-.84-3.16-3.14-3.16h-6.95v3.34h.42c1.58,0,1.89,.36,1.89,2.27v27.24h7.77Zm3.43,0h7.71V18.87c0-2.32-.9-3.16-3.16-3.16h-4.56v26.27Zm-14.61,0V15.73h-4.57c-2.26,0-3.15,.84-3.15,3.16v23.1h7.72Zm29.63-15.09c0,13.08-9.41,22.59-22.32,22.59s-22.35-9.51-22.35-22.59,9.42-22.59,22.35-22.59,22.32,9.56,22.32,22.59m4.57,0c0-15.38-11.51-26.9-26.89-26.9s-26.9,11.52-26.9,26.9,11.51,26.89,26.9,26.89,26.89-11.47,26.89-26.89"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.8a3804fd82594a4278e68265c14dca58.svg";
export { ForwardRef as ReactComponent };